var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrowSvgrepoCom({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--emojione",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 30,
    fill: "#4fd1d9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M30.3 16L15 32l15.3 16V37.4H49V27.1H30.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowSvgrepoCom);
export default __webpack_public_path__ + "static/media/left-arrow-svgrepo-com.4ed0a51304dd2775d0700bd5ab51450c.svg";
export { ForwardRef as ReactComponent };